import { useEffect, useRef } from 'react';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { IdField } from '@sdk/types';

import AddEmployeesModal from '@web/onboarding/Checklist/AddEmployeesModal/AddEmployeesModal';
import { AddPersonaCollectionUser } from '@web/onboarding/Checklist/onboardingChecklist.types';

type Props = {
  currentUser: AuthUserType;
  locations: IdField[];
  addPersonaCollectionUser: AddPersonaCollectionUser;
  shouldOpenInviteEmployeesModal: boolean;
  setShouldOpenInviteEmployeesModal: (value: boolean) => void;
};

const InviteEmployeesModal = ({
  currentUser,
  locations,
  addPersonaCollectionUser,
  shouldOpenInviteEmployeesModal,
  setShouldOpenInviteEmployeesModal,
}: Props) => {
  const addEmployeesModalRef = useRef(null);

  useEffect(() => {
    if (shouldOpenInviteEmployeesModal) addEmployeesModalRef.current?.open();
  }, [shouldOpenInviteEmployeesModal]);

  return (
    <>
      <AddEmployeesModal
        ref={addEmployeesModalRef}
        currentUser={currentUser}
        locations={locations}
        addPersonaCollectionUser={addPersonaCollectionUser}
        onCloseCallback={() => setShouldOpenInviteEmployeesModal(false)}
      />
    </>
  );
};

export default InviteEmployeesModal;
